import React, { useContext, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import _startsWith from 'lodash/startsWith';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';
import { AuthContext } from 'context/AuthContext';
import { useAppContext } from 'utils/hooks';
import { ReactComponent as LockIcon } from 'assets/img/icons/lock-fill.svg';

export default function RoleSwitch() {
  const { push } = useHistory();
  const { pathname } = useLocation();

  const { isSSRMode } = useAppContext();
  const { roles, appType, isWarehouseEnabled } = useContext(AuthContext);

  const { groups, groupsMap } = useMemo(() => {
    const groups = [
      { label: 'Admin', value: 'admin', route: '/' },
      {
        label: 'Warehouse',
        value: 'warehouse',
        route: '/w',
        hide: !isWarehouseEnabled
      },
      { label: 'Store', value: 'store', route: '/s' }
    ];
    const groupsMap = groups.reduce((acc, group) => {
      acc[group.value] = group;
      return acc;
    }, {});

    return { groups, groupsMap };
  }, [isWarehouseEnabled]);

  const activeRole = useMemo(() => {
    if (pathname === '/w' || _startsWith(pathname, '/w/')) return 'warehouse';
    if (pathname === '/s' || _startsWith(pathname, '/s/')) return 'store';
    return 'admin';
  }, [pathname]);

  const activeRoleLabel = _get(groupsMap, `[${activeRole}].label`, '');

  const options = useMemo(() => {
    const { enabled, locked } = groups.reduce(
      (acc, { label, route, value, hide }) => {
        const isLocked = !_get(roles, value, false);
        if (!hide) {
          const list = isLocked ? acc.locked : acc.enabled;
          list.push(
            <UiKit.Dropdown.Option
              key={value}
              isActive={activeRole === value}
              onClick={() => push(route)}
              disabled={isLocked}
            >
              {label}
              <If test={isLocked}>
                <LockIcon className={styles.lockIcon} />
              </If>
            </UiKit.Dropdown.Option>
          );
        }
        return acc;
      },
      { enabled: [], locked: [] }
    );

    return [...enabled, ...locked];
  }, [groups, roles, activeRole, push]);

  if (!appType.retex || isSSRMode) return null;

  return (
    <UiKit.Dropdown>
      <UiKit.Dropdown.Trigger>{activeRoleLabel}</UiKit.Dropdown.Trigger>
      <UiKit.Dropdown.Menu>{options}</UiKit.Dropdown.Menu>
    </UiKit.Dropdown>
  );
}
